import { render, staticRenderFns } from "./Hub.vue?vue&type=template&id=cc54bfa4&"
import script from "./Hub.vue?vue&type=script&lang=js&"
export * from "./Hub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3153440642/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc54bfa4')) {
      api.createRecord('cc54bfa4', component.options)
    } else {
      api.reload('cc54bfa4', component.options)
    }
    module.hot.accept("./Hub.vue?vue&type=template&id=cc54bfa4&", function () {
      api.rerender('cc54bfa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Hub.vue"
export default component.exports